import { MrfiktivAttachmentsViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { SignDocumentDataAccessLayer } from "@/store/modules/access-layers/sign-document.access-layer";
import { ISignDocument, SignDocument } from "./sign-document.entity";

interface IHasDocument {
  documentId?: string;
  document?: ISignDocument | null;
}

interface IHasAttachments {
  attachments?: IAttachments;
}

interface IHasPrimaryDocumentUpdate {
  updatePartial(dto: { documentId?: string; attachments?: { documentIds: string[] } }): Promise<unknown>;
}

class AttachmentsBase implements MrfiktivAttachmentsViewModelGen {
  documentIds: string[];

  constructor(data?: MrfiktivAttachmentsViewModelGen) {
    this.documentIds = data?.documentIds ?? [];

    for (const doc of data?.documents ?? []) {
      SignDocumentDataAccessLayer.set(new SignDocument(doc as any));
    }
  }

  get documents(): ISignDocument[] {
    return this.documentIds
      .map((id) => SignDocumentDataAccessLayer.maps.id.get(id)?.[0])
      .filter((doc): doc is ISignDocument => Boolean(doc));
  }

  get dto() {
    return { documentIds: this.documentIds };
  }

  /**
   * Promotes an attachment to be the entity's primary document, demoting the
   * previous primary document (if any) into the attachments list.
   */
  static async selectPrimary(
    entity: IHasDocument & IHasAttachments & IHasPrimaryDocumentUpdate,
    newPrimaryId: string
  ): Promise<void> {
    const oldPrimaryId = entity.documentId;
    if (oldPrimaryId === newPrimaryId) {
      return;
    }

    const documentIds = Array.from(
      new Set(
        (entity.attachments?.documentIds ?? [])
          .filter((id) => id !== newPrimaryId)
          .concat(oldPrimaryId ? [oldPrimaryId] : [])
      )
    );

    await entity.updatePartial({ documentId: newPrimaryId, attachments: { documentIds } });
  }
}

type IAttachments = AttachmentsBase;
class Attachments extends AttachmentsBase {}

export { Attachments, IAttachments, IHasAttachments, IHasDocument, IHasPrimaryDocumentUpdate };
